import { render } from "./CreatePayment1.vue?vue&type=template&id=976feb72"
import script from "./CreatePayment1.vue?vue&type=script&lang=js"
export * from "./CreatePayment1.vue?vue&type=script&lang=js"

import "./CreatePayment1.vue?vue&type=style&index=0&id=976feb72&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__